/**
 * The sizes used in this application.
 */
class Sizes {

    // **************** APPLICATION BREAKPOINTS ****************

    static xs = 0;
    static sm = 576;
    static md = 768;
    static lg = 992;
    static xl = 1200;
    static xxl = 1400;

    /**
     * Returns the string representation of the given size,
     * @param {number} size
     */
    static toString(size: number): string | undefined {
        switch (size) {
            case this.xs:
                return 'xs';
            case this.sm:
                return 'sm';
            case this.md:
                return 'md';
            case this.lg:
                return 'lg';
            case this.xl:
                return 'xl';
            case this.xxl:
                return 'xxl';
        }
        return undefined
    }

    /**
     * Returns the numeric representation of the given size in string format,
     * @param {string} size
     */
    static toNumeric(size: string): number | undefined {
        switch (size) {
            case 'xs':
                return this.xs;
            case 'sm':
                return this.sm;
            case 'md':
                return this.md;
            case 'lg':
                return this.lg;
            case 'xl':
                return this.xl;
            case 'xxl':
                return this.xxl;
        }
        return undefined;
    }


    // **************** APPLICATION Sizes ****************

    public static readonly defaultPagePadding = 20;

}

export default Sizes;

